import { render, staticRenderFns } from "./BonusList.vue?vue&type=template&id=da72b862&"
import script from "./BonusList.vue?vue&type=script&lang=js&"
export * from "./BonusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports